import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { CongratulationsComponent } from './congratulations/congratulations.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { FrequentlyAskedQuestionsComponent } from './frequently-asked-questions/frequently-asked-questions.component';
import { HomeComponent } from './home/home.component';
import { InstructionsComponent } from './instructions/instructions.component';
import { LoginComponent } from './login/login.component';
import { NgModule } from '@angular/core';
import { PersonDetailsGuardService, LoginGuardService, AuthGuard } from './common/auth-guard-service';
import { PortfolioReviewComponent } from './portfolio-review/portfolio-review.component';
import { PreviousUniversityComponent } from './previous-university/previous-university.component';
import { Routes, RouterModule } from '@angular/router';
import { ScholarshipComponent } from './scholarship/scholarship.component';
// import { SignupComponent } from './signup/signup.component';
import { SponsorsParticularsComponent } from './sponsors-particulars/sponsors-particulars.component';
import { GetstartedComponent } from './getstarted/getstarted.component';
import { OtppageComponent } from './otppage/otppage.component';
import { AuthorizationComponent } from './authorization/authorization.component';
import { PaymentsuccessComponent } from './paymentsuccess/paymentsuccess.component';
import { PaymentfailureComponent } from './paymentfailure/paymentfailure.component';
import { SerialPinloginComponent } from './serial-pinlogin/serial-pinlogin.component';
import { AppdashboardComponent } from './appdashboard/appdashboard.component';
import { ResetpasswordemailComponent } from './resetpasswordemail/resetpasswordemail.component';
import { ResetnewpasswordComponent } from './resetnewpassword/resetnewpassword.component';
import { PaymentPendingComponent } from './payment-pending/payment-pending.component';

const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'instructions',
    component: InstructionsComponent,
  },

  {
    path: 'signup',
    component: GetstartedComponent,
  },
  {
    path: 'verify-otp',
    component: OtppageComponent,
  },
  {
    path: 'auth-payment',
    component: AuthorizationComponent,
  },

  { 
    path: 'payment-pending', 
    component: PaymentPendingComponent 
  },

  {
    path: 'main-applcation-login',
    component: SerialPinloginComponent,

  },

  {
    path: 'main-application-dashboard',
    component: AppdashboardComponent,
    canActivate: [AuthGuard] // ✅ ADD THIS

  },
  {
    path: 'login',
    component: LoginComponent,
  },

   {
    path: 'reset-password-email',
    component: ResetpasswordemailComponent,
  },

   {
    path: 'reset-password',
    component: ResetnewpasswordComponent,
  },

  {
    path: 'logout',
    component: LoginComponent,
  },

  {
    path: 'payment-success',
    component: PaymentsuccessComponent,
  },

  {
    path: 'payment-cancelled',
    component: PaymentfailureComponent,
  },


  {
    path: 'congratulations',
    component: CongratulationsComponent,
    canActivate: [LoginGuardService],
  },

  {
    path: 'contact-us',
    component: ContactUsComponent,
  },
 


  {
    path: 'portfolio-review',
    component: PortfolioReviewComponent,
    canActivate: [LoginGuardService],
  },
  {
    path: 'previous-university',
    component: PreviousUniversityComponent,
    canActivate: [LoginGuardService],
  },

  {
    path: 'scholarship',
    component: ScholarshipComponent,
    canActivate: [LoginGuardService],
  },
  {
    path: 'sponsors-particulars',
    component: SponsorsParticularsComponent,
    canActivate: [LoginGuardService],
  },

  {
    path: 'faqs',
    component: FrequentlyAskedQuestionsComponent,
  },

];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes, {
      useHash: true,
      enableTracing: true, // Add this for debugging
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
